import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { promotionsAccessRoles } from './access';

export const promotionsRoutes: RouteObject[] = [
  {
    path: 'promotions',
    async lazy() {
      const { PromotionsPage } = await import('./pages/PromotionsPage');
      return { Component: PromotionsPage };
    },
    handle: defineHandle({
      roles: [...promotionsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.promotions',
    }),
  },
  {
    path: 'promotions/:id',
    async lazy() {
      const { PromotionDetailPage } = await import('./pages/PromotionDetailPage');
      return { Component: PromotionDetailPage };
    },
    handle: defineHandle({
      roles: [...promotionsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.promotions',
    }),
  },
];
